/**
 * 题目 V2 tokens 消费开关（question_list / record.question_list 等）
 *
 * true  — 优先用题目 `tokens`（及 split_data[].tokens）驱动 word_en 槽位 / 直接展示
 * false — 完全走旧逻辑（word_en / en 分词等），忽略 tokens（测试期默认关闭）
 *
 * 数据稳定后改为 true 即可全量启用；勿删旧逻辑。
 */
export const USE_QUESTION_V2_TOKENS = true

/**
 * 用同级 `en` 给 tokens 补 leading/trailing 标点（展示/输入槽；不改 surface）
 *
 * true  — expectedWords / 词卡旁路标点启用；匹配失败则该题不加标点（安全回退）
 * false — 关闭补点，行为与改前完全一致（一键撤回）
 *
 * 打字模式仍用 statement.en，不受本开关影响。
 */
export const ENRICH_TOKENS_PUNCT_FROM_EN = true
